<template>
  <div 
    id="flash_container" 
    class="flash-message" 
    :class="[{ 'active': isActive }, messageType]"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    alert: {
      type: String,
      default: ''
    },
    notice: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      message: '',
      isActive: false,
      messageType: ''
    }
  },

  created () {
    this.$eventHub.$on('showFlashMessage', this.ajaxMessage)
  },

  mounted () {
    if(this.alert){
      this.showMessage(this.alert)
      this.messageType = 'flash-message--alert'
    } else if(this.notice){
      this.showMessage(this.notice)
      this.messageType = 'flash-message--notice'
    }
  },

  methods: {
    ajaxMessage (messageObj) {
      this.messageType = `flash-message--${messageObj.type}`
      this.showMessage(messageObj.message)
    },

    showMessage (message) {
      this.message = message
      this.isActive = true
      setTimeout(this.hide, 4000)
    },

    hide () {
      this.isActive = false
      setTimeout(function() { this.message = '' }, 1000)
    }
  }
}
</script>

<style lang="scss">
  .flash-message {
    background-color: white;
    padding: 8px;
    text-align: center;

    position: fixed;
    top: -100px;
    right: 0;
    left: 0;

    transition: top 1s ease-out;

    &--alert { background-color: rgba(#f7c3c3, .8); }
    &--notice { background-color: rgba(#c6f7c3, .8); }

    &.active {
      top: 0;
      z-index: 9999;
    }
  }
</style>
